import pjson from '../../package.json';

let version = 'NOT-SET';

if (pjson?.version) {
  version = pjson.version;
}

class ScScriptTag extends HTMLElement {

  componentDefinition: any;
  
  constructor() {
    // Always call super first in constructor
    super();
  }

  connectedCallback() {       
   // write element functionality in here   
   this.setAttribute('fb-component-version', version);

   const scriptEle = document.createRange().createContextualFragment(this.componentDefinition.html);
   document.body.append(scriptEle);
  }    
}

customElements.define('sc-script-tag', ScScriptTag);

export default ScScriptTag;
